module.exports = {
  __init__: [ 'modeling', 'bpmnUpdater' ],
  __depends__: [
    require(51),
    require(26),
    require(78),
    require(66),
    require(76),
    require(121),
    require(241),
    require(174),
    require(135),
    require(230),
    require(147),
    require(237)
  ],
  bpmnFactory: [ 'type', require(27) ],
  bpmnUpdater: [ 'type', require(29) ],
  elementFactory: [ 'type', require(30) ],
  modeling: [ 'type', require(31) ],
  layouter: [ 'type', require(28) ],
  connectionDocking: [ 'type', require(248) ]
};
